import axios from 'axios';
import { CHAT_SERVICE_API_URL } from '../../config';

export const chatAxe = axios.create();

chatAxe.defaults.validateStatus = (status) => status < 500;

chatAxe.defaults.baseURL = CHAT_SERVICE_API_URL;
